'use client';

import {
  BodyLinkV3,
  LayoutGrid,
  TypographyRhythm,
  TypographyV3,
} from '@jouzen/ecom-components';

const Content = () => {
  return (
    <LayoutGrid>
      <TypographyRhythm className="col-main">
        <TypographyV3 Element="h1" variant="h1">
          KÄYTTÖEHDOT
        </TypographyV3>
        <TypographyV3>
          <em>Edellinen päivitys: 18.5.2018</em>
        </TypographyV3>
        <TypographyV3>
          Tervetuloa ja kiitos mielenkiinnostasi Ouraa kohtaan! Olet
          tarkistamassa näitä käyttöehtoja, koska käytät, olet ostanut tai
          harkitset ostavasi Oura-palveluja (”Oura-palvelut”). Ne koostuvat
          älysormuksesta tai muusta elektronisesta laitteesta (”Oura-tuote”),
          jota käytetään Oura-mobiilisovelluksella (”mobiilisovellus”) ja
          verkkosivuston kautta osoitteessa ouraring.com (”verkkosivusto”)
        </TypographyV3>
        <TypographyV3>
          NÄMÄ KÄYTTÖEHDOT MUODOSTAVAT OIKEUDELLISEN SOPIMUKSEN SINUN JA OURAN
          VÄLILLE. LUE NE HUOLELLISESTI ENNEN OURA-PALVELUJEN KÄYTTÖÄ.
          Käyttämällä Oura-palveluja osoitat hyväksyväsi nämä käyttöehdot
          (”käyttöehdot”). Jos et hyväksy näitä käyttöehtoja, et voi käyttää
          Oura-palveluja eikä sinun tule ostaa Oura-palveluja.
        </TypographyV3>
        <TypographyV3>
          Oura-palvelut on kehittänyt ja ne omistaa Oura Health Oy, josta
          käytetään näissä käyttöehdoissa nimitystä ”Oura” tai ”me” eri
          sijamuodoissa. Sinusta käytetään näissä käyttöehdoissa nimitystä
          ”sinä” eri sijamuodoissa.
        </TypographyV3>
        <TypographyV3 Element="h2" variant="h3">
          Tuki ja kysymykset
        </TypographyV3>
        <TypographyV3>
          Jos haluat kysyä jotakin Oura-palvelujen asennuksesta tai käytöstä tai
          sinulla on teknisiä vaikeuksia, voit tutustua usein esitettyihin
          kysymyksiin verkkosivustollamme osoitteessa ouraring.com tai lähettää
          meille sähköpostia osoitteeseen
          <strong>support@ouraring.com</strong>
        </TypographyV3>
        <TypographyV3 Element="h2" variant="h3">
          Palvelujen ja ehtojen muutokset
        </TypographyV3>
        <TypographyV3>
          Voimme muuttaa Oura-palveluja tai lopettaa ne milloin tahansa osittain
          tai kokonaan ilman ennakkoilmoitusta. Hyväksyt sen, ettei Oura ole
          korvausvelvollinen sinulle tai kolmansille osapuolille tällaisesta
          toiminnasta.
        </TypographyV3>
        <TypographyV3>
          Voimme muuttaa näitä käyttöehtoja ajoittain. Uusimmat käyttöehdot ovat
          saatavilla Ouran kotisivuilla, ja viimeisen päivityksen päivämäärä
          näkyy näiden käyttöehtojen yläreunassa. Voimme ilmoittaa suuremmista
          muutoksista Oura-palveluissa tai sähköpostitse. Hyväksyt tällaiset
          muutetut käyttöehdot jatkamalla Oura-palvelujen käyttöä.
        </TypographyV3>
        <TypographyV3 Element="h2" variant="h3">
          Oura-palvelujen käyttövaatimukset
        </TypographyV3>
        <TypographyV3>
          Vahvistat olevasi vähintään 18-vuotias ja voivasi hyväksyä nämä
          käyttöehdot laillisesti omasta puolestasi tai edustamasi osapuolen
          puolesta. Katso myös näiden käyttöehtojen kohta Varotoimenpiteet.
        </TypographyV3>
        <TypographyV3>
          Täydellinen Oura-kokemus edellyttää Oura-tuotetta, Internet-yhteyttä
          mobiilisovellukseen ja verkkosivustoon sekä muita tarvittavia ohjelmia
          (jos sellaisia on). Näitä elementtejä on ehkä päivitettävä ajoittain
          suorituskyvyn parantamiseksi, ja jonkin elementin suorituskyky voi
          vaikuttaa kokonaisuuden suorituskykyyn. Olet itse vastuussa
          Internet-yhteyden ja mobiililaitteen hankinnasta Oura-palvelujen
          käyttöä varten.
        </TypographyV3>
        <TypographyV3 Element="h2" variant="h3">
          Varotoimenpiteet
        </TypographyV3>
        <TypographyV3>
          Huomaa, että Oura-palveluja ei ole tarkoitettu minkään sairauden tai
          lääketieteellisen tilan diagnosointiin, hoitoon, parantamiseen tai
          ehkäisyyn. Oura-palveluissa olevat tiedot ja ohjeet on tarkoitettu
          vain tiedoksi, eivätkä ne korvaa terveydenhoidon ammattilaisten tai
          lääkäreiden antamia palveluja. Kysy aina neuvoa lääkäriltä, ennen kuin
          muutat unirytmiäsi tai aktiviteettejasi Oura-palvelujen tietojen tai
          ohjeiden perusteella, tai jos haluat kysyä jotakin sairauteen
          liittyvää. Älä koskaan ohita ammattimaisia lääketieteellisiä neuvoja
          tai viivästytä niiden hankkimista, koska olet lukenut jotakin
          Oura-palveluista tai niiden kautta. Emme vastaa terveysongelmista,
          joita voi ilmetä Oura-palvelujen kautta saatujen tietojen tai ohjeiden
          vuoksi. Jos muutat unirytmiäsi tai aktiviteettejasi Oura-palvelujen
          perusteella, hyväksyt sen, että teet niin täysin omalla vastuullasi.
          On tärkeää kuunnella kehosi reaktioita. Jos esimerkiksi tunnet
          odottamatonta, toistuvaa tai pitkäaikaista kipua, uupumusta tai
          epämukavuutta muutettuasi unirytmiäsi tai aktiviteettejasi, on
          suositeltavaa kysyä neuvoa lääkäriltä ennen tällaisten muutosten
          jatkamista. Oura-palvelujen tiedot ja ohjeet voivat olla
          harhaanjohtavia, jos fysiologiset toimintosi ja reaktiosi poikkeavat
          merkittävästi väestön keskiarvoista lääketieteellisen tilan tai
          harvinaisten luontaisten ominaisuuksien takia.
        </TypographyV3>
        <TypographyV3>
          Varo, ettei käyttämäsi Oura-tuote takerru kiinteisiin rakenteisiin tai
          raskaisiin esineisiin, kun liikut tai siirrät tällaisia painavia
          esineitä.
        </TypographyV3>
        <TypographyV3>
          <strong>
            Jos sormeesi tulee punoitusta tai ihoärsytystä Oura-tuotteen käytön
            vuoksi, ota tuote heti pois. Jos oireet kestävät pidempään kuin 2–3
            päivää Oura-tuotteen pois ottamisen jälkeen, ota yhteyttä
            ihotautilääkäriin.
          </strong>
        </TypographyV3>
        <TypographyV3 Element="h2" variant="h3">
          Yrityksen yhteystiedot
        </TypographyV3>
        <TypographyV3>
          Postiosoite: Elektroniikkatie 10, 90590 Oulu
        </TypographyV3>
        <TypographyV3>
          Puhelin: +358 50 466 8390 (Huomaa, että puhelut tähän numeroon eivät
          päädy asiakaspalveluun. Jos haluat kysyä jotakin tuesta, tilauksista,
          palautuksista tai tuotetiedoista, lähetä sähköpostia osoitteeseen{' '}
          <strong>support@ouraring.com</strong>, jotta voimme palvella sinua
          nopeasti.)
        </TypographyV3>
        <TypographyV3 Element="h2" variant="h3">
          Tietosuojaselosteemme
        </TypographyV3>
        <TypographyV3>
          Oura-palveluja säätelee Ouran tietosuojaseloste, joka on luettavissa
          osoitteessa{' '}
          <BodyLinkV3 color="inherit" href="/privacy-policy">
            ouraring.com/privacy-policy
          </BodyLinkV3>
        </TypographyV3>
        <TypographyV3 Element="h3" variant="h4">
          Oura-palvelujen rajoitettu lisenssi ja omistajuus
        </TypographyV3>
        <TypographyV3>
          Sinulle myönnetään tällä asiakirjalla ei-poissulkeva, peruutettavissa
          oleva ja ei siirrettävissä oleva lisenssi Oura-palvelujen käyttöön
          näiden käyttöehtojen mukaisesti.
        </TypographyV3>
        <TypographyV3>
          Oura tai sen lisenssinhaltijat omistavat kaikki oikeudet
          Oura-palveluihin, mukaan lukien rajoituksetta kaikki tekijänoikeudet,
          tavaramerkit, tietotaidon ja muut niihin sisältyvät
          immateriaalioikeudet. Et saa kopioida (linkittämällä, kehystämällä tai
          muulla menetelmällä), siirtää, jaella, tallentaa, muokata, purkaa tai
          käyttää johdannaisten pohjana, esittää julkisesti tai hyödyntää
          kaupallisesti mitään Oura-palvelujen osaa muulloin kuin sen ollessa
          tarpeen esitettäessä, ladattaessa tai tulostettaessa (ilman muutoksia)
          jotakin omaan ei-kaupalliseen käyttöön. Kaikki oikeudet
          Oura-palveluihin, joita Oura ei myönnä sinulle erikseen, säilyvät
          Ouralla ja sen lisenssinhaltijoilla. Jos näitä käyttöehtoja rikotaan,
          Oura voi omalla päätöksellään kieltää tai estää pääsyn
          Oura-palveluihin heti. Tällöin sinun on tuhottava välittömästi
          mahdolliset kopiot, jotka olet luonut jostakin Oura-palvelujen osasta.
        </TypographyV3>
        <TypographyV3>
          Voit ehdottaa Ouralle muutoksia tai parannuksia kaikkiin
          Oura-palveluihin tai johonkin niiden osaan. Kun teet tällaisen
          ehdotuksen Ouralle, myönnät Ouralle kokonaan sen omistajuuden ja
          immateriaalioikeudet.
        </TypographyV3>
        <TypographyV3 Element="h2" variant="h3">
          Korvausvastuu
        </TypographyV3>
        <TypographyV3>
          Sitoudut suojaamaan Ouraa ja sen kumppaneita, tytäryhtiöitä,
          palveluntarjoajia, lisenssinmyöntäjiä, toimihenkilöitä, johtajia,
          työntekijöitä ja agentteja korvausvaatimuksilta tai toimenpiteiltä,
          mukaan lukien rajoituksetta kohtuulliset juridiset kulut ja
          kirjanpitokulut, jotka johtuvat seuraavista suoraan tai oletettavasti
          siitä, että (a) rikot näitä käyttöehtoja tai (b) rikot Ouran
          immateriaalioikeuksia, kolmannen osapuolen oikeuksia tai sovellettavaa
          lainsäädäntöä käyttäessäsi Oura-palveluja.
        </TypographyV3>
        <TypographyV3 Element="h2" variant="h3">
          Paikallinen lainsäädäntö ja vientivalvonta
        </TypographyV3>
        <TypographyV3>
          Ostamalla Oura-palveluja ja käyttämällä niitä sitoudut noudattamaan
          paikallista lainsäädäntöä sekä Yhdysvaltojen ja joidenkin muiden
          maiden vientirajoituksia tuotteille tai tiedoille.
        </TypographyV3>
        <TypographyV3 Element="h2" variant="h3">
          Kolmansien osapuolten palvelut
        </TypographyV3>
        <TypographyV3>
          Pyrimme tuottamaan käyttäjille lisäarvoa sisällyttämällä
          Oura-palveluihin linkkejä tai viittauksia kolmansien osapuolten
          verkkosivustoihin tai palveluihin. Emme pysty ohjaamaan tällaisia
          verkkosivustoja tai palveluja, emmekä ota mitään vastuuta
          minkäänlaisista vahingoista tai menetyksistä, jotka johtuvat niiden
          sisällöstä, toiminnoista tai käytännöistä. Jos päätät käyttää näitä
          kolmansien osapuolten verkkosivustoja tai palveluja, teet sen omalla
          vastuullasi. Oura suosittelee, että luet tällaisten kolmansien
          osapuolten verkkosivustojen tai palvelujen käyttöehdot (jos sellaisia
          on) ennen niiden käyttöä.
        </TypographyV3>
        <TypographyV3 Element="h2" variant="h3">
          Sisällön ja takuun vastuuvapauslauseke
        </TypographyV3>
        <TypographyV3>
          OURA JA SEN TYTÄRYHTIÖT TOIMITTAVAT OURA-PALVELUT ”SELLAISINAAN”
          MUUTOIN KUIN OURA-TUOTTEEN RAJATUSSA TAKUUSSA ALLA MÄÄRITELLYN OSALTA.
        </TypographyV3>
        <TypographyV3>
          OURA TAI SEN KUMPPANIT, TOIMITTAJAT TAI TYTÄRYHTIÖT EIVÄT ANNA
          MINKÄÄNLAISIA NIMENOMAISIA TAI EPÄSUORIA TAKUITA OURA-PALVELUJEN
          TOIMINNALLE (MUKAAN LUKIEN OURA-TUOTTEET), TAI SISÄLLÖLLE TAI NIISSÄ /
          NIIDEN KAUTTA SAATAVILLE TIEDOILLE. OURA JA SEN KUMPPANIT, TOIMITTAJAT
          JA TYTÄRYHTIÖT SANOUTUVAT LISÄKSI IRTI KAIKISTA NIMENOMAISISTA JA
          EPÄSUORISTA TAKUISTA OURA-PALVELUILLE (MUKAAN LUKIEN OURA-TUOTTEET).
          TÄHÄN SISÄLTYVÄT RAJOITUKSETTA EPÄSUORAT TAKUUT MYYNTIKELPOISUUDELLE,
          OMISTUKSELLE, SOPIVUUDELLE TIETTYYN TARKOITUKSEEN JA OIKEUKSIEN
          RIKKOMATTOMUUDELLE. OURA EI MYÖSKÄÄN TAKAA, ETTÄ OURA-PALVELUJEN
          KÄYTTÖ ON KESKEYTYMÄTÖNTÄ, SAATAVILLA MILLOIN TAHANSA TAI TIETYSTÄ
          PAIKASTA, SUOJATTUA TAI VIRHEETÖNTÄ, ETTÄ VIAT KORJATAAN TAI ETTÄ
          OURA-PALVELUT (MUKAAN LUKIEN KAIKKI OURA-TUOTTEET) OVAT VIRUKSETTOMIA
          EIVÄTKÄ SISÄLLÄ MUITA MAHDOLLISESTI HAITALLISIA OSIA.
        </TypographyV3>
        <TypographyV3>
          RAJOITETTU TAKUU OURA-TUOTTEELLE, ESIMERKIKSI SORMUKSELLE. OURA TAKAA
          ALKUPERÄISELLE LOPPUKÄYTTÄJÄLLE/OSTAJALLE, ETTEI OURA-TUOTTEESSA OLE
          MATERIAALI- JA VALMISTUSVIKOJA, KAHDEN (2) VUODEN AJAN
          OSTOPÄIVÄMÄÄRÄSTÄ. Jos ostohetkellä voimassa oleva paikallinen
          lainsäädäntö edellyttää pitempää takuuaikaa kuin kaksi (2) vuotta,
          tätä takuuta pidennetään tällaisen lainsäädännön edellyttämässä
          määrin. Takuuaikana Oura korjaa tai vaihtaa veloituksetta kaikki
          Oura-tuotteen osat, jotka eivät vastaa annettua rajattua takuuta. Olet
          vastuussa kaikista tähän liittyvistä kuljetusmaksuista. Korvaavat
          tuotteet voivat olla uusia tai kunnostettuja harkintamme mukaan. Tämä
          rajattu takuu ei koske (i) normaalia kulumista, mukaan lukien naarmut
          ja lommot, (ii) Oura-tuotteeseen sisältyviä kulutusosia, kuten akkuja,
          ellei tuotteen vika ole ilmennyt materiaali- tai valmistusvirheen
          vuoksi, (iii) vaurioita, jotka johtuvat Oura-tuotteen käytöstä sen
          mukana toimitettujen ohjeiden tai verkkosivustolla olevien ohjeiden
          vastaisesti, (iv) vaurioita, jotka johtuvat onnettomuudesta, tulvasta,
          tulipalosta tai väärinkäytöstä, (v) vaurioita, jotka johtuvat tehdystä
          huollosta tai Oura-tuotteen peukaloinnista tai muuntamisesta sellaisen
          henkilön toimesta, jolla ei ole Ouran valtuutusta, tai (vi)
          Oura-tuotteen käyttöä muulla sovelluksella tai ohjelmistolla kuin
          mobiilisovelluksella.
        </TypographyV3>
        <TypographyV3>
          Oura pidättää yksinomaisen oikeuden korjata tai vaihtaa Oura-tuote tai
          tarjota täyttä hyvitystä harkintansa mukaan. Tällainen hyvitys on
          ainoa ja yksinomainen korvaus takuun rikkomisesta. Takuukorjauksille
          ja vaihdoille annetaan uusi takuu, joka on yhdeksänkymmentä (90)
          päivää tai alkuperäisen kahden vuoden takuun jäljellä oleva aika sen
          mukaan, kumpi aika on pitempi.
        </TypographyV3>
        <TypographyV3 Element="h2" variant="h3">
          Vastuurajoitus
        </TypographyV3>
        <TypographyV3>
          OURA TAI MIKÄÄN SEN TYTÄRYHTIÖ EI OLE MISSÄÄN TAPAUKSESSA VASTUUSSA
          SUORISTA, EPÄSUORISTA, SATUNNAISISTA, RANGAISTAVISTA TAI VÄLILLISISTÄ
          VAHINGOISTA (MUKAAN LUKIEN RAJOITUKSETTA VAHINGOT, JOTKA AIHEUTUVAT
          MENETETYISTÄ VOITOISTA TAI TIEDOISTA TAI LIIKETOIMINNAN
          KESKEYTYMISESTÄ), JOTKA JOHTUVAT OURA-PALVELUJEN KÄYTÖSTÄ,
          KYVYTTÖMYYDESTÄ KÄYTTÄÄ NIITÄ TAI NIIDEN KÄYTÖN TULOKSISTA,
          RIIPPUMATTA SIITÄ; PERUSTUVATKO NÄMÄ VAHINGOT TAKUUSEEN, SOPIMUKSEEN,
          OIKEUDENLOUKKAUKSEEN TAI MUUHUN OIKEUDELLISEEN TEORIAAN, JA
          RIIPPUMATTA SIITÄ, ONKO OURALLE ILMOITETTU TÄLLAISTEN VAHINKOJEN
          MAHDOLLISUUDESTA. OURAN OURA-PALVELUISTA JOHTUVA TAI NIIHIN LIITTYVÄ
          KOKONAISVASTUU (RIIPPUMATTA TOIMENPITEEN TAI VAATIMUKSEN MUODOSTA,
          JOKA VOI OLLA ESIMERKIKSI SOPIMUS, TAKUU, OIKEUDENLOUKKAUS, ANKARA
          VASTUU, LAIMINLYÖNTI TAI MUU OIKEUDELLINEN TEORIA) ON RAJATTU 100
          YHDYSVALTAIN DOLLARIIN. OURAN TYTÄRYHTIÖILLÄ, TOIMITTAJILLA JA
          KUMPPANEILLA EI OLE MINKÄÄNLAISTA VERKKOSIVUSTOSTA JOHTUVAA VASTUUTA.
          Joissakin sijainneissa sovellettava lainsäädäntö ei ehkä salli kaikkia
          edellä kuvattuja rajoituksia. Tällöin nämä rajoitukset ovat voimassa
          siinä määrin kuin sovellettava lainsäädäntö sen sallii.
        </TypographyV3>
        <TypographyV3 Element="h2" variant="h3">
          Tavaramerkit ja patentit
        </TypographyV3>
        <TypographyV3>
          ŌURA-logo, Ō-logo ja ŌURA ovat Oura Health Ltd:n tavaramerkkejä tai
          rekisteröityjä tavaramerkkejä. Niille on patentti tai niille on haettu
          patenttia. © Oura Health Oy (Oura) 2014–2018. Kaikki oikeudet
          pidätetään. Sinulle ei myönnetä epäsuorasti tai muulla tavoin
          lisenssejä tai käyttöoikeuksia Oura-palveluissa näkyviin merkkeihin.
          Vähintään yksi Ouran omistama patentti (tai kolmansilta osapuolilta
          lisensoitu patentti) koskee Oura-tuotteita sekä ominaisuuksia ja
          palveluja, jotka ovat käytettävissä Ouran ylläpitämien Oura-palvelujen
          kautta.
        </TypographyV3>
        <TypographyV3 Element="h2" variant="h3">
          Sovellettava lainsäädäntö ja riitautukset
        </TypographyV3>
        <TypographyV3>
          YK:n kansainvälistä tavaran kauppaa koskevista sopimuksista tehty
          yleissopimus ei koske näitä käyttöehtoja tai Oura-palvelujen minkään
          osan hankintaa.
        </TypographyV3>
        <TypographyV3>
          Jos asut Yhdysvalloissa, näitä käyttöehtoja säätelee Kalifornian
          osavaltion lainsäädäntö riippumatta minkään lainkäyttöalueen
          lainsäädännön ristiriitaperiaatteista. Jos asut jossakin muussa
          maassa, näitä käyttöehtoja säätelee Suomen lainsäädäntö riippumatta
          minkään lainkäyttöalueen lainsäädännön ristiriitaperiaatteista.
        </TypographyV3>
        <TypographyV3>
          Molempien osapuolten on pyrittävä parhaansa mukaan ratkaisemaan
          ystävällismielisissä neuvotteluissa mahdolliset ristiriidat, jotka
          johtuvat näistä käyttöehdoista, niiden osan olemassaolosta,
          voimassaolosta, päättämisestä tai tulkinnasta, ja kiistat, jotka
          koskevat Oura-palvelujen käyttöä. Jos osapuolet eivät löydä ratkaisua
          ystävällismielisesti, kumpi tahansa osapuoli voi siirtää tällaisen
          kiistan sitovaan välimiesmenettelyyn. Jos asut Yhdysvalloissa, (A)
          välimiesmenettely pidetään AAA:n (American Arbitration Association)
          sovitteluaikaan voimassa olevien sovittelusääntöjen mukaisesti, (B)
          AAA toimii nimittävänä viranomaisena ja vastaa välimiesmenettelyn
          järjestämisestä AAA:n sovittelusääntöjen mukaisesti ja (C)
          välimiesmenettelyn paikka on Kalifornian San Francisco.
        </TypographyV3>
        <TypographyV3>
          Jos asut jossakin muussa maassa tai jollakin muulla alueella, (1)
          välimiesmenettely pidetään Suomen kansainvälisen kauppakamarin (ICC)
          sovitteluhetkellä voimassa olevien sovittelusääntöjen mukaisesti
          (”ICC:n sovittelusäännöt”), (2) ICC toimii nimittävänä viranomaisena
          ja vastaa välimiesmenettelyn järjestämisestä ICC:n sovittelusääntöjen
          mukaisesti ja (3) välimiesmenettelyn paikka on Helsinki.
        </TypographyV3>
        <TypographyV3>
          Kummassakin tapauksessa välimiesmenettelyn suorittaa yksi sovittelija,
          joka on oikeuden ammattilainen tai vastaava ammattilainen ja jolla ei
          saa olla aiempia sidoksia kumpaankaan osapuoleen (”välimies”).
          Välimiesmenettelyn ratkaisu on lopullinen ja sitova, eikä siitä voi
          valittaa. Välimiehen palkkio on määritettävä kirjallisesti
          kolmenkymmenen (30) päivän kuluessa kuulemisesta, elleivät Oura ja
          asiakas ole sopineet muuta.
        </TypographyV3>
        <TypographyV3>
          Edellä mainitusta huolimatta Oura voi hakea kieltomääräystä tällaista
          rikkomusta vastaan toimivaltaiselta tuomioistuimelta, jos olet
          rikkonut Ouran immateriaalioikeuksia tavalla, joka aiheuttaisi
          peruuttamatonta vahinkoa.
        </TypographyV3>
        <TypographyV3 Element="h2" variant="h3">
          Yleiset
        </TypographyV3>
        <TypographyV3>
          Kaikkien asiakirjojen, ilmoitusten ja näiden käyttöehtojen tulkintojen
          ensisijainen kieli on englanti. Osiot Varotoimenpiteet, Korvausvastuu,
          Sisällön ja takuun vastuuvapauslauseke, Vastuurajoitus sekä
          Sovellettava lainsäädäntö ja riitautukset pysyvät voimassa sen
          jälkeen, kun käyttöoikeutesi Oura-palveluihin on päättynyt jostakin
          syystä tai ilman syytä.
        </TypographyV3>
        <TypographyV3>
          Jos Oura ei käytä näiden käyttöehtojen mukaisia oikeuksia tai
          määräyksiä, se ei tarkoita luopumista tällaisista oikeuksista tai
          määräyksistä, ellei Oura ole suostunut siihen kirjallisesti. Nämä
          käyttöehdot muodostavat koko sopimuksen asiakkaan ja Ouran välillä
          tässä mainittuihin aiheisiin liittyen, ja ne ohittavat kaikki aiemmat
          tai tämänhetkiset suulliset tai kirjalliset sopimukset. Et voi siirtää
          tätä sopimusta muille osapuolille, ja yritykset tehdä niin
          mitätöidään.
        </TypographyV3>
        <TypographyV3>
          Oura Health Oy, Elektroniikkatie 10, 90590 Oulu
        </TypographyV3>
        <TypographyV3 Element="h2" variant="h1">
          TOIMITUSEHDOT
        </TypographyV3>
        <TypographyV3>
          <em>Edellinen päivitys: 10.1.2018</em>
        </TypographyV3>
        <TypographyV3>
          Oura-kauppa toimii Suomesta käsin. Tämä voi tarkoittaa, että maksuusi
          lisätään ulkomaanmaksuista johtuvia kuluja, jos käytät luottokorttia.
          Tarkista lisätiedot kortin myöntäneestä pankista. Sormukset lähetetään
          EU:sta. Oura toimittaa tuotteet vuoden 2010 Incoterms®-sääntöjen
          mukaisesti alla mainitulla tavalla.
        </TypographyV3>
        <TypographyV3 Element="h3" variant="h3">
          Euroopan unioni ja Yhdysvallat
        </TypographyV3>
        <TypographyV3>
          Toimitettuna tullattuna (DDP, Delivered Duty Paid)
        </TypographyV3>
        <TypographyV3>
          Oura vastaa tuotteiden toimituksesta nimettyyn paikkaan ostajan maassa
          ja maksaa kaikki kustannukset tuotteiden kuljettamisesta kohteeseen,
          mukaan lukien tuontiverot.
        </TypographyV3>
        <TypographyV3 Element="h3" variant="h3">
          Euroopan unionin ja Yhdysvaltojen ulkopuoliset maat
        </TypographyV3>
        <TypographyV3>
          Toimitettuna määräpaikalle (DAP, Delivered at Place)
        </TypographyV3>
        <TypographyV3>
          Oura maksaa kuljetuksen nimettyyn paikkaan, pois lukien
          tuontiselvitykseen liittyvät kustannukset, ja kantaa kaikki riskit
          siihen asti, että tuotteet ovat valmiina ostajan purettaviksi
          kuljetuksesta.
        </TypographyV3>
      </TypographyRhythm>
    </LayoutGrid>
  );
};

export default Content;
